/** Accessible tier colors shared by the website and exported cards. */
export const TIER_COLORS = {
  clean: '#455b47',
  moderate: '#795d21',
  unhealthy: '#a6422f',
  very_unhealthy: '#6c526f',
  hazardous: '#8e3741',
};
export const SYSTEM_SANS = '"Helvetica Neue", Helvetica, Arial, sans-serif';
export const DESIGNS = {
  current: {
    ink: '#25251f',
    paper: '#fffdf8',
    accent: '#455b47',
    highlight: '#e4c977',
    muted: '#65655b',
    display: SYSTEM_SANS,
    weight: 600,
  },
  previous: {
    ink: '#25251f',
    paper: '#fffdf8',
    accent: '#455b47',
    highlight: '#e4c977',
    muted: '#65655b',
    display: SYSTEM_SANS,
    weight: 600,
  },
};
export const tierTokens = Object.fromEntries(
  Object.entries(TIER_COLORS).map(([id, color]) => [`--tier-${id}`, color]),
);
